import QuickLink from 'components/Main/Dashboard/QuickLink'
import React from 'react'
import ApprovalsCont from '../../../components/Main/Dashboard/Approvals/ApprovalsCont'
import AttendanceCont from './Attendance/AttendanceCont'
import WallTimeLine from './WallTimeLine'

function Dashboard() {
  return (
    <div className="flex">
      <div className="flex-grow">
        <WallTimeLine/>
      </div>
      <div className="flex flex-col">
        <QuickLink />
        <ApprovalsCont />
        <AttendanceCont />
      </div>
    </div>
  )
}

export default Dashboard
